import React,{useState,useEffect} from "react";
import CompanyNavbar from "./CompanyNavbar";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function EditJobsPage() {
    const ID = Cookies.get("log_id");
    const {id} = useParams();
    const [job,setJob] = useState("");
    const [description,setDescription] = useState("");
    const [Skills,setSkills] = useState("");
    const [Location,setLocation] = useState("");
    const [Experience,setExperience] = useState("");
    const [number,setNumber] = useState("");
    const [last,setLast] = useState("");
    const [join,setJoin] = useState("");
    const [jobtype,setType] = useState("");
    const navigate = useNavigate();
    function Fetch_Job_details() {
        axios.get(`${url.path}/fetch_job_details/${id}/`)
        .then((res) =>{
            if(res.data.status){
                var job = res.data.jobs;
                setJob(job.Job_Name);
                setDescription(job.Description);
                setSkills(job.Skills);
                setLocation(job.Location);
                setExperience(job.Experience);
                setNumber(job.Number_Vaccancy);
                setLast(job.Last_Date_Apply);
                setJoin(job.Expected_Join);
                setType(job.Job_Type);
            }
        }).catch((err) => {
                console.log("ERROR", err);
            });
            }
    useEffect(() =>{
        Fetch_Job_details();
    }, [])
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    function handleUpdate(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('ID',ID);
        formdata.append('id',id);
        formdata.append('job',job);
        formdata.append('description',description);
        formdata.append('skills',Skills);
        formdata.append('location',Location);
        formdata.append('experience',Experience);
        formdata.append('number',number);
        formdata.append('last',last);
        formdata.append('join',join);
        formdata.append('type',jobtype);
        axios.post(`${url.path}/update_job/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Job Details Updated..'
                })
                navigate("/view_jobs_company");
            }
        }).catch((err) => {
            console.log("ERROR", err);
        });
    }
    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Edit Job</h1>
                </div>
                <br />
                <form onSubmit={handleUpdate}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Job Title</label>
                            <input type="text" value={job} onChange={(e) =>setJob(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Job Description</label>
                            <input type="text" value={description} onChange={(e) =>setDescription(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Skills Required</label>
                            <input type="text" value={Skills} onChange={(e) =>setSkills(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Location</label>
                            <input type="text" value={Location} onChange={(e) =>setLocation(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Experience Needed(eg:5 year in python)</label>
                            <input type="text" value={Experience} onChange={(e) =>setExperience(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Number of Vaccancy</label>
                            <input type="number" value={number} onChange={(e) =>setNumber(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Last Date To Apply</label>
                            <input type="date" value={last} onChange={(e) =>setLast(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Expected Joining Date</label>
                            <input type="date" value={join} onChange={(e) =>setJoin(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label className="lab2">Job Type</label>
                            <div className="radio-group">
                               
                                    <label>
                                    <input type="radio" name="job_type" value="Open Source" id="opensource" onChange={(e) =>setType(e.target.value)} checked={jobtype === "Open Source"}  /> Open Source
                                </label>
                                
                                <label>
                                    <input type="radio" name="job_type" value="Exact Source" id="exactsource" onChange={(e) =>setType(e.target.value)} checked={jobtype === "Exact Source"}  /> Exact Source
                                </label>
                                
                            </div>
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Update</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default EditJobsPage;